import React, { useCallback, useEffect } from "react";
import { createPortal } from "react-dom";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import OutsideClickHandler from "react-outside-click-handler";
import cn from "classnames";
import styles from "./modal.module.sass"
import Icon from "../../Icon";

const Modal = ({ outerClassName, heading, visible, onClose, children, width }) => {
  
    const escFunction = useCallback((e) => {
      if (e.keyCode === 27) {
        onClose();
      }
    },
    [onClose]
    );

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  useEffect(() => {
    if (visible) {
      const target = document.querySelector("#modal");
      disableBodyScroll(target);
    } else {
      clearAllBodyScrollLocks();
    }
  }, [visible]);

  return createPortal(
    visible && (
      <div id="modal" className={width == 'fullWidth' ? styles.fullModal : styles.modal}>
        <div className={width== 'fullWidth' ? cn(styles.fullWidth, outerClassName) : width== 'small' ? cn(styles.outerSmall, outerClassName) : width == 'medium' ? cn(styles.outerMedium, outerClassName): width == 'large' ? cn(styles.outerLarge, outerClassName) : cn(styles.outer, outerClassName)}>
          <OutsideClickHandler disabled onOutsideClick={onClose}>
            {children}
            {width != 'fullWidth' &&
              <button className={heading ? styles.closeHeading : styles.close} onClick={onClose}>
                <Icon name="close" size="16" />
              </button>
            }
          </OutsideClickHandler>
        </div>
      </div>
    ),
    document.body
  );
};

export default Modal;
